import { render, staticRenderFns } from "./VariationLists.vue?vue&type=template&id=298f9c36&"
import script from "./VariationLists.vue?vue&type=script&lang=js&"
export * from "./VariationLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports